import Vue from "vue";
import Router from "vue-router";
import Page from "../views/Page.vue";
import NotFound from "../views/NotFound.vue";
Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/:jobIndex/:jobCategory/:job/job-application-form",
    //   name: "job-application",
    //   component: Page,
    //   meta: {
    //     jobApplication: true
    //   }
    // },
    { 
      path: '/404', 
      name: "not-found-page", 
      component: NotFound 
    },
    {
      path: "/*",
      name: "pages",
      component: Page
    },
  ],

scrollBehavior (to: any, from: any, savedPosition: any) {
  return new Promise((resolve: any, reject: any) => {
    setTimeout(() => {
      resolve({ x: 0, y: 0 })
    }, 350)
  })
}
});
